import * as React from "react";
import { Auth } from "aws-amplify";
import { useSelector } from "react-redux";

import { ReduxApplicationState } from "../types/ReduxTypes/ReduxApplicationState";

export function useCurrentAuthenticatedUser() {
  const agencyId = useSelector((state: ReduxApplicationState) => state.agency!.agencyId);
  const [currentUsername, setCurrentUsername] = React.useState<string>("");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    (async () => {
      const checkAuth = async () => {
        const { username } = await Auth.currentAuthenticatedUser();
        setCurrentUsername(username);
      };

      await checkAuth();

      setIsLoading(false);
    })();
  }, []);

  return {
    agencyId,
    currentUserLoading: isLoading,
    currentUsername,
  };
}
